import React from 'react';
import { Alert } from 'react-bootstrap';

function EmailPreview({ htmlContent, title }) {
    if (!htmlContent) {
        return (
            <Alert variant="warning" className="mb-0">
                No email content available for this campaign.
            </Alert>
        );
    }

    return (
        <>
            <div className="px-3 py-2 border-bottom bg-light email-queue-preview-meta">
                <div>
                    <strong>Subject:</strong> {title || '—'}
                </div>
                <p className="text-danger email-queue-preview-note mb-0 mt-2">
                    Preview only. Editing will not save anything.
                </p>
            </div>
            <div
                className="email-queue-preview-content p-3"
                dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
        </>
    );
}

export default EmailPreview;
